export const createMicrolessonText = {
  titleHeading: 'Title',
  titlePlaceholder: 'Give your lesson a name',
  descriptionHeading: 'Description',
  descriptionPlaceholder: 'Describe your lesson',
  assessmentHeading: 'Assessment',
  assesmentInfo: 'Enable assessment to evaluate learner understanding',
  passingScoreHeading: 'Passing score',
  passingScoreInfo: 'Set the minimum passing score (0-100)',
  cancel: 'Cancel',
  saveAndClose: 'Save and close',
  nextStep: 'Next step',
  imageUploadInfo1: 'Upload an icon to illustrate your lesson',
  imageUploadInfo2: 'PNG, JPG or GIF',
  browse: 'Browse',
  microlessonCreated: 'Microlesson created',
  microlessonEdited: 'Microlesson edited',
};
